import LocaleContext, {
  LocaleConsumer,
  LocaleContextProps,
  LocaleProvider,
  LocaleProviderProps,
} from "./Locale";

export {
  LocaleConsumer,
  LocaleContextProps,
  LocaleProvider,
  LocaleProviderProps,
};
export default LocaleContext;
